import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Validasi env
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ Supabase env variables tidak ada!');
  console.error('URL:', supabaseUrl ? 'ADA' : 'KOSONG');
  console.error('Anon Key:', supabaseAnonKey ? 'ADA' : 'KOSONG');
}

// CLIENT ANON SAJA (untuk frontend)
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// CEK KONEKSI
export const checkConnection = async () => {
  try {
    const { data, error } = await supabase
      .from('customers')
      .select('id', { count: 'exact', head: true });
    
    if (error) throw error;
    console.log('✅ Supabase connected!');
    return { online: true };
  } catch (error) {
    console.warn('⚠️ Supabase offline:', error.message);
    return { online: false, error: error.message };
  }
};